import { CONTACT_LABELS, CONTACT_STATUS, contactLabel } from '@/entities/contact/labels'
import type { ChangeEvent, ContactLabel, ContactStatus } from '@/shared/api/types'

const CONTACT_LABEL_VALUES = new Set<ContactLabel>(CONTACT_LABELS.map(({ value }) => value))

const EVENT_TITLES = {
  label: 'Метка клиента',
  meeting: 'Новая договорённость',
  decision_maker: 'Контакт ЛПР',
  do_not_call: 'Запрет на звонки',
  status: 'Статус клиента',
  fact: 'Новый факт',
} as const

export function eventTitle(event: ChangeEvent): string {
  if (event.kind === 'fact' && event.fieldLabel.trim()) return event.fieldLabel
  return EVENT_TITLES[event.kind]
}

export function eventPerson(event: ChangeEvent): string {
  return event.displayName.trim() || event.phoneFormatted
}

/** Значение события в человекочитаемом виде, а не серверным кодом. */
export function formatEventValue(event: ChangeEvent, value: string): string {
  if (event.kind === 'label' || event.field === 'label') {
    return CONTACT_LABEL_VALUES.has(value as ContactLabel)
      ? contactLabel(value as ContactLabel)
      : value || 'Без метки'
  }

  if (event.kind === 'status' || event.field === 'status') {
    return CONTACT_STATUS[value as ContactStatus]?.label ?? (value || 'Не указано')
  }

  return value.trim() || 'Не указано'
}

/** Ссылка ведёт сразу к реплике, если сервер сохранил её смещение. */
export function eventCallHref(event: ChangeEvent): string | null {
  if (event.callId === null) return null
  return `/calls/${event.callId}${event.offsetMs !== null ? `?t=${event.offsetMs}` : ''}`
}

/** Страницы курсора могут пересечься при появлении нового события. */
export function mergeClientEvents(current: ChangeEvent[], next: ChangeEvent[]): ChangeEvent[] {
  const seen = new Set(current.map(({ id }) => id))
  return [...current, ...next.filter(({ id }) => !seen.has(id))]
}
